import type { WorkspaceProjection } from '@localagent/sdk';

export type WorkspaceFilesAvailability =
  | { state: 'ready' }
  | { state: 'waking' }
  | { state: 'sleeping' }
  | { state: 'other-computer'; message: string }
  | { state: 'this-computer-offline'; message: string }
  | { state: 'error'; message: string };

export function workspaceFilesAvailability(
  projection: WorkspaceProjection,
  thisDeviceId: string | null
): WorkspaceFilesAvailability {
  if (projection.workstation.status === 'starting') return { state: 'waking' };
  if (projection.capabilities.execution && projection.capabilities.content_readable) {
    return { state: 'ready' };
  }
  if (projection.actions.wake.available) return { state: 'sleeping' };
  const isLocal = projection.assignment.routing_class === 'local';
  const availability = isLocal ? projection.actions.save : projection.actions.wake;
  if (availability.available) {
    return { state: 'error', message: 'Workspace projection contradicts its content capabilities' };
  }
  const { reason, message } = availability.refusal;
  if (isLocal && reason === 'workstation_disconnected') {
    if (thisDeviceId === null) {
      throw new Error('Local file availability needs this computer’s device id');
    }
    const boundHere = projection.workstation.device_id === thisDeviceId;
    return { state: boundHere ? 'this-computer-offline' : 'other-computer', message };
  }
  return { state: 'error', message };
}
